import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { HomeData } from './types';

export function useHome() {
    return useQuery({ queryKey: ['ref-home'], queryFn: async () => (await (await fetch('/api/ref-home')).json()) as HomeData });
}

export function useRemoveFavorite() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (eid: string) => (await (await fetch(`/api/ref-home/favorites/${eid}`, { method: 'DELETE' })).json()) as HomeData,
        onSuccess: (data) => qc.setQueryData(['ref-home'], data),
    });
}
